import React from 'react';
import { Box, Typography, Button, Paper, Grid2, useTheme, Icon } from '@mui/material';
import Section from './Section';

const SeccionDescarga = () => {
  const theme = useTheme();

  const handleDescargarGoogle = () => {
    window.open('https://play.google.com/store/apps/details?id=com.rauhtech.rauhapp&pcampaignid=web_share', '_blank');
  };

  return (
    <Section
      id="descarga-app"
      hasBackground={true}
    >
      <Paper
        elevation={0}
        sx={{
          borderRadius: '16px',
          overflow: 'hidden',
          bgcolor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          p: { xs: 3.5, md: 5 },
          border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1.5px solid #e2e8f0',
          boxShadow: theme.palette.mode === 'dark' ? '0 8px 30px rgba(0, 0, 0, 0.5)' : '0 4px 20px rgba(0, 0, 0, 0.04)',
        }}
      >
        <Grid2 container spacing={{ xs: 3, md: 4 }} alignItems="center">
          <Grid2 size={{ xs: 12, md: 8 }}>
            <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, px: 1.5, py: 0.5, bgcolor: theme.palette.mode === 'dark' ? 'rgba(241, 91, 40, 0.12)' : '#f8fafc', border: theme.palette.mode === 'dark' ? '1px solid rgba(241, 91, 40, 0.3)' : '1px solid #e2e8f0', borderRadius: '6px', mb: 2 }}>
              <Icon sx={{ color: theme.palette.secondary.main, fontSize: 18 }}>get_app</Icon>
              <Typography variant="caption" sx={{ color: theme.palette.secondary.main, fontWeight: 800, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                DESCARGA OFICIAL
              </Typography>
            </Box>

            <Typography
              variant="h3"
              sx={{
                fontWeight: 900,
                fontSize: { xs: '1.8rem', sm: '2.3rem', md: '2.6rem' },
                mb: 1.5,
                lineHeight: 1.2,
                color: theme.palette.text.primary,
              }}
            >
              Comienza a gestionar tus rifas desde tu teléfono
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
                fontSize: { xs: '0.95rem', md: '1.05rem' },
                lineHeight: 1.6,
                mb: 3.5,
                maxWidth: 580,
              }}
            >
              Disponible de forma gratuita en Google Play Store. Crea tu primera rifa en menos de 2 minutos y compártela de inmediato con tus clientes.
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                onClick={handleDescargarGoogle}
                startIcon={<Icon>android</Icon>}
                sx={{
                  fontWeight: 800,
                  fontSize: '1rem',
                  py: 1.3,
                  px: 3.5,
                  borderRadius: '8px',
                  borderWidth: '1.5px',
                  '&:hover': {
                    borderWidth: '1.5px',
                    bgcolor: 'rgba(241, 91, 40, 0.06)',
                  },
                }}
              >
                Descargar en Google Play
              </Button>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: theme.palette.text.secondary, px: 1 }}>
                <Icon sx={{ color: '#10b981', fontSize: 20 }}>verified</Icon>
                <Typography variant="caption" sx={{ fontWeight: 700 }}>
                  Versión Oficial RAUH TECH
                </Typography>
              </Box>
            </Box>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              sx={{
                p: 2.5,
                bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : '#f8fafc',
                borderRadius: '12px',
                border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
                textAlign: 'center',
              }}
            >
              <img
                src="/assets/imgs/play-store.png"
                alt="Google Play Store"
                style={{ height: '70px', borderRadius: '8px' }}
              />
              <Typography variant="caption" sx={{ display: 'block', mt: 1, color: theme.palette.text.secondary, fontWeight: 600 }}>
                Compatible con Android 7.0 o superior
              </Typography>
            </Box>
          </Grid2>
        </Grid2>
      </Paper>
    </Section>
  );
};

export default SeccionDescarga;